module.exports = __webpack_public_path__ + "img/neck opening.7aa9361a.png";